<template>
  <div
    class="matrix_layoutMain container matrix_layoutUseMatrix matrix_fullPageWithImage"
    :class="[getClassNameContainer, getBundleClass]"
  >
    <div class="row">
      <div class="col-md-6 matrix_layoutMatrixContainerColSidebar">
        <div class="fpc_placeholder">
          <!-- <img :src="getBaseUrl + `images/fpc-placeholder.png`" /> -->
        </div>
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appSummarySelectedPageOptions></appSummarySelectedPageOptions>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
        <appOptionsTable>
          <appOptionsContainer></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <!-- <appUploadTable v-if="0" alwaysShow="true"></appUploadTable> -->
        <appPersonalizationButton
          v-show="
            getPersonalizationFullPage && showPersonalizationButton // eslint-disable-next-line
          "
          v-if="!getUploadPersonalizationOneProduct"
          class="matrix_personzalizeButtonMobile"
        >
        </appPersonalizationButton>
        <appAddToCartButton
          v-show="
            showAddToCartButton || // eslint-disable-next-line
              (!showPersonalizationButton && !showUploadTable)
          "
          class="matrix_addToCartButtonMobile"
          :showPersonalizationButton="showPersonalizationButton"
          :showUploadTable="showUploadTable"
          :showAddToCartButton="showAddToCartButton"
        ></appAddToCartButton>
        <appQuotationButton v-if="0"></appQuotationButton>
      </div>
      <div class="col-md-6 matrix_layoutMatrixContainerColMain">
        <div v-if="0" class="matrix_layoutHeader">
          <appProductPartsNamesContainer></appProductPartsNamesContainer>
        </div>
        <div class="matrix_productPartsMainContainer matrix_table">
          <component :is="getBundleProductPartType"></component>
          <!-- <appBackToMatrixButton></appBackToMatrixButton> -->
          <!-- <appUploadTable></appUploadTable> -->
          <!-- <appPersonalizationButton
            v-show="getMatrixComplete && getPersonalizationFullPage"
            v-if="!getUploadPersonalizationOneProduct"
            class="matrix_personzalizeButtonMain"
          ></appPersonalizationButton> -->
        </div>
        <div v-if="getBundleIsActive" class="matrix_summaryInformation">
          <appUploadContainerBundle></appUploadContainerBundle>
        </div>
        <div class="matrix_summaryInformation">
          <appSummaryTable></appSummaryTable>
          <appInformationTable></appInformationTable>
        </div>
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div>
        <appPersonalizationButton
          v-show="getPersonalizationFullPage && showPersonalizationButton"
          v-if="!getUploadPersonalizationOneProduct"
          class="matrix_personzalizeButtonMain"
        ></appPersonalizationButton>
        <appUploadTable
          v-show="showUploadTable"
          alwaysShow="true"
        ></appUploadTable>
        <appAddToCartButton
          v-show="
            showAddToCartButton || // eslint-disable-next-line
              (!showPersonalizationButton && !showUploadTable)
          "
          class="matrix_addToCartButtonMain"
          :showPersonalizationButton="showPersonalizationButton"
          :showUploadTable="showUploadTable"
          :showAddToCartButton="showAddToCartButton"
        ></appAddToCartButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useConfigStore } from "@/stores/modules/config";
import { useBundleStore } from "@/stores/modules/bundle";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useUrlsStore } from "@/stores/modules/urls";

export default {
  computed: {
    ...mapState(useConfigStore, [
      "getMatrixComplete",
      "getAddToCartFullPage",
      "getPersonalizationFullPage"
    ]),
    ...mapState(useUrlsStore, ["getBaseUrl"]),
    ...mapState(useBundleStore, [
      "getBundleProductPartType",
      "getBundleClass",
      "getBundleIsActive"
    ]),
    ...mapState(useWebproductStore, [
      "getUploadPersonalizationOneProduct",
      "getIsUploadPersonalizationFullPage",
      "getNumberOfUploads",
      "getOtherOptions",
      "getIsFileTypePersonalizationAttributeSelected"
    ]),
    ...mapState(usePersonalizeStore, ["getPersonalizationStatus"]),
    showAddToCartButton: function () {
      if (this.getUploadPersonalizationOneProduct) {
        // test also if the personalization has been made
        return this.getPersonalizationStatus && this.getAddToCartFullPage;
      } else return this.getAddToCartFullPage || this.getPersonalizationStatus;
    },
    showPersonalizationButton() {
      return this.getIsFileTypePersonalizationAttributeSelected(
        "Personalization"
      );
    },

    showUploadTable() {
      return this.getIsFileTypePersonalizationAttributeSelected("Upload");
    }
  }
};
</script>
